var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { ArrowChevronRight } from '../../icons';
import { Checkbox } from '../Checkbox';
import { ContentButton, IconContainer, Container } from './ActionItem.styles';
export var ActionItemCheckbox = React.memo(function (_a) {
    var name = _a.name, value = _a.value, onChange = _a.onChange, checked = _a.checked, onClick = _a.onClick, children = _a.children, isActive = _a.isActive, rest = __rest(_a, ["name", "value", "onChange", "checked", "onClick", "children", "isActive"]);
    return (React.createElement(Container, __assign({ isActive: isActive, noPadding: true }, rest),
        React.createElement(IconContainer, null,
            React.createElement(Checkbox, { name: name !== null && name !== void 0 ? name : '', value: value !== null && value !== void 0 ? value : '', onChange: onChange, checked: checked })),
        React.createElement(ContentButton, { onClick: onClick },
            children,
            onClick !== undefined && React.createElement(ArrowChevronRight, { tiny: true }))));
}, function (p, n) { return p.checked === n.checked && p.isActive === n.isActive; });
ActionItemCheckbox.displayName = 'ActionItemCheckbox';
//# sourceMappingURL=ActionItemCheckbox.js.map